<template>
    <v-radio-group
        :mandatory="false"
        v-model="address"
    >
        <v-radio
            v-for="address in addresses"
            :key="address.id"
            :label="$order.getShippingAddressString(address)"
            :value="address.id"
        ></v-radio>
    </v-radio-group>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations } = createNamespacedHelpers('ShippingAddressForm');

export default {
    name: 'ShippingAddressRadioGroup',
    props: {
        addresses: {
            type: Array,
            default: [],
        },
    },
    computed: {
        ...mapState(['selectedAddress']),
        address: {
            get() {
                if (!this.selectedAddress) {
                    this.addresses.some(address => {
                        this.setSelectedAddress(address.id);
                        return true;
                    });
                }
                return this.selectedAddress;
            },
            set(id) {
                this.addresses.some(address => {
                    if (address.id === id) {
                        this.setAddress(address);
                        return true;
                    }
                });
                this.setSelectedAddress(id);
            },
        },
    },
    methods: {
        ...mapMutations(['setSelectedAddress', 'setAddress']),
    },
};
</script>
